import { render, staticRenderFns } from "./TextExplanation.vue?vue&type=template&id=7689fce3&scoped=true&"
import script from "./TextExplanation.vue?vue&type=script&lang=js&"
export * from "./TextExplanation.vue?vue&type=script&lang=js&"
import style0 from "./TextExplanation.vue?vue&type=style&index=0&id=7689fce3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7689fce3",
  null
  
)

export default component.exports